module.exports = __webpack_public_path__ + "img/tag_green_oval.617a8c65.svg";